<div class="d-flex flex-column content-wrapper flex-grow-1">
  <div class="pnf-upper d-flex flex-row flex-grow-1 align-items-center justify-content-center">
    <div class="d-flex flex-column align-items-center gap-5 text-center">
      <h1>Uh oh, Something Went Wrong</h1>
      <h4>
        we understand that having these delays are disruptive to <br />
        your business & apologize for the inconvenience
      </h4>
      <button type="button" pButton size="large" class="fw-bold" (click)="tryAgain()">Try Again</button>
      <a class="text-lg" href="mailto:clearsupport@cmgfi.com">Notify IT Team</a>
    </div>
  </div>
  <div class="pnf-lower d-flex flex-row">
    <div class="w-50 text-center pnf-lower-left">
      <img src="../../../assets/images/couch.png" alt="Couch" width="371px" />
    </div>
    <div class="w-50 text-center pnf-lower-right">
      <img src="../../../assets/images/table.png" alt="Couch" width="214px" />
    </div>
  </div>
</div>
